import { Row, Tag } from "@narmi/design_system";

interface SelectedProductTagProps {
  productName: string;
  iconClass?: string;
}

export function SelectedProductTag({ productName, iconClass }: SelectedProductTagProps) {
  return (
    <Tag
      label={
        <Row gapSize="xs" justifyContent="center" alignItems="center">
          {iconClass && (
            <Row.Item shrink>
              <div className={iconClass} />
            </Row.Item>
          )}
          <Row.Item>{productName}</Row.Item>
        </Row>
      }
    />
  );
}
